import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GenericTableModule } from "../../generic-table/generic-table.module";
import { ModalOrdersComponent } from "./modal-orders.component";
import {ModalGenericoModule} from '../../../../shared/components/modal-generico/modal-generico.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GenericTableModule
    ],
    declarations: [
        ModalOrdersComponent
    ],
    exports: [
        ModalOrdersComponent
    ]
})
export class ModalOrdersModule { }
